import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: false,
    error: null,
    getAccessList: [],
    createSubAdminSuccessState: false,
    adminUserListData: {},
    isEditAdminSuccess : null ,
}
export const setting = createSlice({
    name: 'setting',
    initialState: {
        loading: false,
        error: null,
        getAccessList: [],
        createSubAdminSuccessState: false,
        adminUserListData: {},
        MainAdminActive: null,
        MainAdminDelete: null
    },
    initialState,
    reducers: {
        createSubAdminLoad: (state) => {
            state.loading = true;
            state.createSubAdminSuccessState = false;
        },
        createSubAdminSuccess: (state, action) => {
            state.loading = false;
            state.createSubAdminSuccessState = true;
        },
        createSubAdminFail: (state) => {
            state.loading = false;
            state.createSubAdminSuccessState = false;
        },

        createSubAdminListLoad: (state) => {
            state.loading = true;
        },
        createSubAdminListSuccess: (state, action) => {
            state.loading = false;
            state.adminUserListData = action.payload;
        },
        createSubAdminListFail: (state) => {
            state.loading = false;
        },

        getAccessListLoad: (state) => {
            state.loading = true;
        },
        getAccessListFail: (state) => {
            state.loading = false;
        },
        getAccessListSuccess: (state, action) => {
            state.loading = false;
            state.getAccessList = action.payload;
        },

        uploadAvatarLoad: (state) => {
            state.loading = true;
        },
        uploadAvatarSuccess: (state) => {
            state.loading = false;
        },

        activeMainAdminLoad: (state) => {
            state.loading = true;
            state.MainAdminActive = false
        },
        activeMainAdminSuccess: (state) => {
            state.loading = false;
            state.MainAdminActive = true;
        },

        deleteMainAdminLoad: (state) => {
            state.loading = true;
            state.MainAdminDelete = false;
        },
        deleteMainAdminSuccess: (state) => {
            state.loading = false;
            state.MainAdminDelete = true;
        },
        editAdminLoad : (state) => {
            state.isEditAdminSuccess = false
        },

        editAdminSuccess : (state) => {
            state.isEditAdminSuccess = true
        }
    }
});

export const {
    createSubAdminLoad,
    createSubAdminFail,
    createSubAdminSuccess,
    createSubAdminListLoad,
    createSubAdminListFail,
    createSubAdminListSuccess,
    getAccessListLoad,
    getAccessListFail,
    getAccessListSuccess,
    activeMainAdminLoad,
    activeMainAdminSuccess,
    deleteMainAdminLoad,
    deleteMainAdminSuccess,
    uploadAvatarLoad,
    uploadAvatarSuccess,
    editAdminLoad,
    editAdminSuccess
} = setting.actions;
export default setting.reducer;
